import { uploadAudioFile } from './api';
import { refreshSession } from './auth';
import { loadRemotePreferences } from './preferences';
import { audioCache } from '../utils/audioCache';

export interface BootstrapResult {
  isPremium: boolean;
  settings: Awaited<ReturnType<typeof loadRemotePreferences>>['settings'];
}

export async function bootstrapAccount(): Promise<BootstrapResult> {
  await refreshSession();

  try {
    const remote = await loadRemotePreferences();
    return {
      isPremium: remote.isPremium,
      settings: remote.settings,
    };
  } catch (error) {
    console.warn('[Bootstrap] Failed to load remote preferences:', error);
    const isPremium = localStorage.getItem('is_premium') === 'true';
    return { isPremium, settings: {} };
  }
}

export async function syncLocalAudioAfterLogin(): Promise<void> {
  try {
    await audioCache.syncAllToServer((file) => uploadAudioFile(file));
  } catch (error) {
    console.warn('[Bootstrap] Failed to sync local audio to server:', error);
  }
}
